import { useRouter } from "next/router";
import type React from "react";
import { Page as Component } from "~/components/specifics/403/Page";

export const Page: React.FC = () => {
	const router = useRouter();
	const { message } = router.query;
	return <Component message={String(message || "")} />;
};
